import { createApp } from 'vue';
import App from './App.vue';
import router from './router';
import './firebase';
import { initAnalytics } from './analytics';
import './styles/base.css';

initAnalytics('public');
createApp(App).use(router).mount('#app');
